export default __webpack_public_path__ + "static/media/09-ART-(4-3).a90dff23.jpg";